type RichtextNode = {
    kind: 'textNode' | 'htmlElement' | 'disclaimer';
};

type TextNode = RichtextNode & {
    value: string;
};

type HtmlElement = RichtextNode & {
    tagName: string;
    children: HeadingRichtext;
};

type DisclaimerItem = {
    displayType: string;
    text: string;
    id: string;
    numericId: string;
};

type Disclaimer = RichtextNode & {
    disclaimers: DisclaimerItem[];
};

type Richtext = TextNode | HtmlElement | Disclaimer;

export type HeadingRichtext = Array<Richtext>;

const processNode = (node: RichtextNode): string => {
    if (node.kind === 'textNode') {
        return (node as TextNode).value;
    }
    if (node.kind === 'htmlElement') {
        return parseHeadingRichtextToString((node as HtmlElement).children);
    }
    return '';
};

export const parseHeadingRichtextToString = (
    richtext?: HeadingRichtext
): string => {
    if (!richtext) return '';

    return richtext.map(processNode).join('');
};
